var map = {
	"./Vectorinfo.svg": "5151",
	"./Vectorinfoerror.svg": "af1a",
	"./Vectorleft.svg": "78e1",
	"./Vectorleft_disabled.svg": "22a0",
	"./Vectorright.svg": "a4cc",
	"./Vectorright_disabled.svg": "1395",
	"./align-justify.svg": "36c5",
	"./allergy_icon.svg": "39c9",
	"./allergy_status.svg": "5f51",
	"./amount_paid.svg": "a04e",
	"./amount_paid_icon.svg": "f838",
	"./analytics_icon.svg": "43e8",
	"./analytics_icon_pink.svg": "5b9a",
	"./appointment_icon.svg": "0743",
	"./appointment_icon_pink.svg": "6d09",
	"./arrived_icon.svg": "e142",
	"./arrived_status.svg": "9a74",
	"./banned_status.svg": "5871",
	"./bannedcustomer_icon.svg": "f088",
	"./bell_icon.svg": "303d",
	"./booked_icon.svg": "45b9",
	"./booked_status.svg": "78ea",
	"./booking_completed.svg": "d720",
	"./booking_created.svg": "4d00",
	"./calendar_icon.svg": "d930",
	"./calendar_icon_pink.svg": "3a06",
	"./cancel_icon.svg": "85e7",
	"./cancel_status.svg": "834f",
	"./chevron-left.svg": "dc03",
	"./class.svg": "63c5",
	"./class_revenue_icon.svg": "387ff",
	"./classbooking_white.svg": "50b5",
	"./classes_icon.svg": "ade9",
	"./classes_icon_pink.svg": "f37c",
	"./clipboard_disable.svg": "4443",
	"./clipboard_white.svg": "3e77",
	"./clipboard_with_events.svg": "1ca5",
	"./clipboard_without_events.svg": "63b6",
	"./close_black.svg": "748f",
	"./close_icon.svg": "3b0a",
	"./close_white.svg": "b804",
	"./completed_icon.svg": "3b94",
	"./completed_status.svg": "f3a0",
	"./crown_icon.svg": "5988",
	"./crown_status.svg": "bed7",
	"./customers_icon.svg": "b922",
	"./customers_icon_pink.svg": "b6b1",
	"./default_products.svg": "dd6c",
	"./deposit_paid_icon.svg": "00c3",
	"./down_arrow_icon.svg": "b225",
	"./down_arrow_pink_icon.svg": "7bcc",
	"./ellipsis.svg": "9ff6",
	"./external_link.svg": "2f90",
	"./facebook_icon.svg": "d647",
	"./fill_form_icon.svg": "238d",
	"./filter_close.svg": "fb48",
	"./filter_open.svg": "7683",
	"./form_filled_icon.svg": "7fa6",
	"./full_payment_icon.svg": "344c",
	"./fullpayment_status.svg": "d261",
	"./google_icon.svg": "6b84",
	"./help_icon.svg": "a186",
	"./help_icon_pink.svg": "495d",
	"./home_icon.svg": "51a6",
	"./home_icon_pink.svg": "5d56",
	"./late_cancel_icon.svg": "1085",
	"./late_cancel_status.svg": "d1b6",
	"./left_arrow.svg": "cf93",
	"./mail_icon.svg": "a2cd",
	"./menu_icon.svg": "a894",
	"./minimize_white.svg": "fa7d",
	"./minus_circle.svg": "dfdb",
	"./minus_icon.svg": "2a1e",
	"./new_customer_status.svg": "01ce",
	"./newcustomer_icon.svg": "5ca7",
	"./noshow_icon.svg": "c944",
	"./noshow_status.svg": "16c6",
	"./notification_icon.svg": "187c",
	"./password_icon.svg": "018f",
	"./plus_circle.svg": "8597",
	"./plus_icon.svg": "d22c",
	"./product_default_img.svg": "e679",
	"./product_revenue_icon.svg": "43c5",
	"./products_icon.svg": "8a3a",
	"./products_icon_pink.svg": "a9b9",
	"./products_in_box.svg": "3ab4",
	"./profile.svg": "e40e",
	"./reports_icon.svg": "e22a",
	"./reports_icon_pink.svg": "18ea",
	"./right_arrow_icon.svg": "bd04",
	"./sales_icon.svg": "c9d9",
	"./sales_icon_pink.svg": "42e0",
	"./search_icon.svg": "b6bf",
	"./service.svg": "d90b",
	"./service_revenue_icon.svg": "5357",
	"./settings_icon.svg": "abdd",
	"./settings_icon_pink.svg": "dc04",
	"./share_icon.svg": "c5d5",
	"./stylist_revenue_icon.svg": "1bff",
	"./tag_icon.svg": "cd3a",
	"./tick_white.svg": "a815",
	"./trash_icon_on_image.svg": "f7c8",
	"./up_arrow_icon.svg": "a995",
	"./upload.svg": "a13b",
	"./upload_image_icon.svg": "e01e",
	"./user_name_icon.svg": "5a14",
	"./view_fill_form_icon.svg": "c341",
	"./view_form_filled_icon.svg": "d9ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";